/* Plain JS, not TS: the Vite plugin that writes the boot screen into index.html (vite.boot-screen.mjs)
   runs in Node at build time, and the page that takes it away runs in the browser. Both read the id
   here. Why the screen exists and when it leaves: packages/ui/docs/schermata-d-avvio.md */

/** The id of the boot screen the served HTML stands on until the first route is drawn. */
export const BOOT_SCREEN_ID = 'volee-boot'

/** Takes the boot screen away, with a clean cut: no fade. Called again, it does nothing. */
export function dismissBootScreen() {
  globalThis.document.getElementById(BOOT_SCREEN_ID)?.remove()
}
